function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextButton } from 'seagull';
import OTPField from "../../pages/unAuthorizedPages/LoginScreen/Steps/OTPField";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./ChangeEmailAddress.module.scss";
const OTPInputSection = _ref => {
  let {
    isLoading,
    control,
    resendCode
  } = _ref;
  const errorMessage = 'Code is invalid. Please try again.';
  return /*#__PURE__*/React.createElement("div", {
    className: styles.sixDigitCodeInput,
    "data-testid": "one-time-password-section"
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "otp",
    rules: {
      required: errorMessage,
      minLength: {
        value: 6,
        message: errorMessage
      }
    },
    render: renderProps => /*#__PURE__*/React.createElement(OTPField, _extends({}, connectControllerToTextField(renderProps), renderProps.field, {
      testid: "one-time-password",
      autoFocus: true,
      width: 360,
      isLoading: isLoading
    }))
  }), /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    "data-testid": "resend-code-button",
    onClick: resendCode
  }, "Resend code"));
};
export default OTPInputSection;